// src/Pages/Owner/OwnerLogin/OwnerLoginPage.jsx
import React, { useState, useEffect } from 'react';
import './OwnerLoginPage.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess, loginFailure } from '../../../store/slices/ownerAuthSlice';
import { loginOwner } from '../../../services/ownerAuthService';

export default function OwnerLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(state => state.ownerAuth);

  // 이미 로그인된 상태면 대시보드로 리다이렉트
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/owner/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await loginOwner(email, password);
      dispatch(loginSuccess(res.access_token));
      navigate('/owner/dashboard');
    } catch (err) {
      const msg = err.response?.data?.detail || '로그인 실패. 이메일 또는 비밀번호를 확인해주세요.';
      setError(msg);
      dispatch(loginFailure(msg));
    }
  };

  return (
    <div className="owner-login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>클럽 관계자 로그인</h2>
        <input
          type="email"
          placeholder="이메일"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login-input"
          required
        />
        <input
          type="password"
          placeholder="비밀번호"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login-input"
          required
        />
        {error && <p className="error-msg">{error}</p>}
        <button type="submit" className="login-button">로그인</button>
      </form>
    </div>
  );
}
